export default __webpack_public_path__ + "static/media/blog-13.5436b4f4.jpg";